import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const GoogleIcon = forwardRef<SVGSVGElement, IconProps>(function ExpandIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.64 9.20468C17.64 8.5665 17.5827 7.95286 17.4764 7.36377H9V10.8451H13.8436C13.635 11.9701 13.0009 12.9233 12.0477 13.5615V15.8197H14.9564C16.6582 14.2529 17.64 11.9456 17.64 9.20468Z"
        fill={color || '#4285F4'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
        fill={color || '#34A853'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.96409 10.7103C3.78409 10.1703 3.68182 9.5935 3.68182 9.00031C3.68182 8.40713 3.78409 7.83031 3.96409 7.29031V4.9585H0.957273C0.347727 6.1735 0 7.54804 0 9.00031C0 10.4526 0.347727 11.8271 0.957273 13.0421L3.96409 10.7103Z"
        fill={color || '#FBBC05'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
        fill={color || '#EA4335'}
      />
    </svg>
  );
});
